import { isEmpty } from 'ts-utils';
import { getUserDocRef } from '../../../helpers/CommonDatabaseOperations';
import { Auth } from '../../../util/Auth';
import { store as baseStore } from '../../Store';

/** Store a users phone number to the database if they're authenticated. */
export async function updatePhoneNumberInDb(store = baseStore): Promise<void> {
  const { userId, phoneNumber } = store.getState().user;

  if (Auth.isUserSignedIn() && !isEmpty(userId) && !isEmpty(phoneNumber)) {
    await getUserDocRef(userId).update({ phoneNumber });
  }
}
